module.exports = __webpack_public_path__ + "static/media/carrier-inactive-hub.c223d7d9.svg";